import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ breaks: true, gfm: true });

export const renderMarkdown = (md) => {
  if (!md) return "";
  const html = marked.parse(md);
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target", "rel"] });
};

export const readingTime = (md) => {
  const words = (md || "").trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 230));
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-AU", {
      day: "numeric", month: "long", year: "numeric",
    });
  } catch { return iso; }
};

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const imageUrl = (ref) => {
  if (!ref) return null;
  if (ref.startsWith("http")) return ref;
  if (ref.startsWith("/api/")) return `${BACKEND}${ref}`;
  // storage path e.g. "foodrecallalerts/blog/abc.png"
  return `${BACKEND}/api/blog/image/${ref}`;
};

export const articleJsonLd = (post, siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.title,
  description: post.meta_description || post.excerpt,
  image: post.hero_image ? imageUrl(post.hero_image) : undefined,
  datePublished: post.publish_date,
  dateModified: post.updated_at,
  author: post.author
    ? { "@type": "Person", name: post.author.name,
        url: `${siteUrl}/blog/author/${post.author.slug}` }
    : undefined,
  publisher: {
    "@type": "Organization", name: "Food Recall Alerts",
    logo: { "@type": "ImageObject", url: `${siteUrl}/img/og-food-recall-alerts.jpg` },
  },
  mainEntityOfPage: `${siteUrl}/blog/${post.slug}`,
});

export const breadcrumbJsonLd = (crumbs, siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem", position: i + 1, name: c.name,
    item: `${siteUrl}${c.path}`,
  })),
});
